import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL + '/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    withCredentials: true
});

// طلب CSRF token قبل كل request
api.interceptors.request.use(async (config) => {
    try {
        await axios.get(`${process.env.REACT_APP_API_URL}/sanctum/csrf-cookie`, {
            withCredentials: true
        });
    } catch (error) {
        console.error('Error fetching CSRF token:', error);
    }
    return config;
});

// اضافة معالج الأخطاء
api.interceptors.response.use(
    response => response,
    error => {
        console.error('API Error:', error.response || error);
        return Promise.reject(error);
    }
);

// اضافة token في كل request
api.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default api;
